"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositOptionsType = void 0;
exports.DepositOptionsType = {
    wireTransferCrypto: 'wire-transfer-crypto',
    cashAccount: 'cash-account',
    ira: 'ira',
    web3: 'web3',
};
//# sourceMappingURL=token.js.map